import { useState, useCallback } from 'react';

/**
 * useCommandPalette — State management for the command palette.
 *
 * The Cmd/Ctrl+K keyboard shortcut is handled by GlobalKeyboardShortcuts,
 * which calls the toggle() function provided by this hook.
 * This avoids duplicate keydown listeners competing with each other.
 *
 * Convoy-050 gt-ux017 — Keyboard Shortcuts Alignment
 */
export function useCommandPalette() {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((prev) => !prev), []);

  return {
    isOpen,
    open,
    close,
    toggle,
  };
}
